<script>
import { POINT_MARKER_ICON_CONFIG } from "../constants/mapSettings";

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },

  mounted() {
    const { Marker } = this.google.maps;

    new Marker({
      position: this.marker.centro,
      marker: this.marker,
      title: this.marker.nombre,
      map: this.map,
      icon: POINT_MARKER_ICON_CONFIG
    });
  },

  render() {}
};
</script>
